const colors = {
  quickBar: "#151C28",
  buttonBGColor: "#333333",
  buttonBgColor: "#3578FD",
  countersBGColor: "#E2E8F0",
  progressColor: "#00B207",
  progressColorInactive: "#F2F2F2",
  headerTextColor: "#2E2A40",
  defaultFontColor: "#253642",
  linkColor: "#669BBC",
  background2: "#FFFFFF",
  greyTextColor: "#9699A0",
  lightGrey: "#F4F6FA",
  greyBackground: "#C4CDD5",
  redText: "#ED1C24",
  mutedText: "#5A7184",
  infoBlue: "#007BFF",
  infoBlueHover: "#0069d9",
  greytext: "#999999",
  black: "#000000",
  borderGrey: "#C5CED6",
  lightBackground: "#F9FAFB",
  fileUploadBG: "#EFEFEF",
  uploadedTextBlue: "#3276E8",
  disabledGrey: "#9F9F9F",
  darkGrey: "#222222",
  greyTypography: "#959EAD",
  outlinedBtnColor: "#1976d2",
  outlineBtnHoverColor: "#1565c0",
  lightBlue: "#f5f9ff",
  mediumGrey1: "#000000",
  lightGreyBlue: "#ecf0f5",
  createInvoiceButton: "#1D1D1D",
  searchInputBorder: "#D0D5DD",
  searchInputText: "#344054",
  tableFieldText: "#667085",
  filterBorder: "#EAECF0",
  darkBrownGrey: "#100f0c",
  mediumBlue: "#5c6ac4",
  ledgerDeleteBtnColor: "#E90810",
  deleteBtnBorderColor: "#e8e3e3",
  deleteBtnDisabledColor: "#bfbdbd",
  ledgerCustomerPaginationBox: "#F0F0F0",
  ledgerGrandTotalPositive: "#00B207",
  ledgerGrandTotalNegative: "#FF0000",
  ledgerModalDivider: "#0000004D",
  sortContainerBG: "#f9fbff",
  sortContainerCPborder: "#979797",
  sortContainerBoxShadow: " #00000040",
  sortFontColor: "#7E7E7E",
  sortActiveFontColor: "#3D3C42",
  mediumGrey: "#F3F3F3",
  dateRangeBoxShadow: "#38416429",
  fieldGreyBG: "#767676",
  documentLableColor: "#84818A",
  documentDisabled: "#B0B0B0",
  buttonBlueBG: "#3578FD",
  buttonBG2: "#f5f5f5",
  subTextColor: "#425583",
  buttonHoverBlue: "#2f6fe4",
  buttonHoverWhite: "#f0f7ff",
  appLayoutBG: "#f6f6f6",
  tableLabelBackground: "#FCFCFD",
  checkDetailsButton: "#E9E9E9",
  paginationCaption: "#B5B7C0",
  customerTablelabel: "#677093",
  customerTableHeaderBG: "#fdfcfd",
  creditNoteTotalPositive: "#008000",
  preBookingStatusGreen: "#7DC07D",
  preBookingStatusOrange: "#E86034",
  primaryBlue: "#EBF1FF",
  trackingbox: "#EBF2FF",
  trackingBoxBorder: "E0E6FF",
  greyBorder: "#EEE",
  helpBoxBorder: "#E6E6E6",
  kpiCardLabels: "#1E374B",
  kpiCardNumbers: "#616265",
  salesAnalyticsCardTopClientBg: "#D9D9D9",
  salesAnalyticsCardLabelText: "#585D6A",
  salesAnalyticsCardHelperText: "#818892",
  salesAnalyticsProductWodLow: "#F16547",
  salesAnalyticsProductWodMedium: "#7EC0C6",
  salesAnalyticsProductWodHigh: "#1FA9B2",
  progressColorKpi: "#047109",
  regressColorKpi: "#D81B1B",
  linePlotBlue: "#0FBEC8",
  linePlotOrange: "#F69778",
  barPlotLightBlue: "#BDDBDD",
  barPlotOrange: "#FF7043",
  orderIntervalActiveBorder: "#D9D9D9",
  orderIntervalLapsedAcc: "#CFEAE6",
  orderIntervalInactiveAcc: "#FBC9B2",
  orderIntervalActiveValue: "#4DC79A",
  orderIntervalLapsedValue: "#F7AA35",
  orderIntervalInactiveValue: "#F36868",
  orderIntervalTitle: "#636874",
  orderIntervalSubtext: "#868C96",
  globalFiltersDivider: "#BCBCBC",
  noDataFoundText: "#6B7280",
  noDataFoundCard: "#E0E0E0",
  wodProductAxisLines: "#98999C",
  wodTooltipArrowBorder: "#CCCCCC",
  redBackground: "#ffebee",
  homePageGreyBG: "#212121",
  serviceCardBackground: "#FEFEF2",
  homePageBg: "#FAFAF9",
  datePickerBorder: "#777777",
  homePageRed: "#EE1C23",
  clickTextBlack: "#1E1E1E",
  hoverRed: "#c41d1d",
  homepageTealText: "#008C90",
  serviceSubtitleText: "#78716C",
  productRed: "#DB3840",
  productInactiveRed: "#DB384045",
  productBorderRed: "#A80005",
  productBorderBlue: "#189CA6",
  //Maltora colors
  primaryButtonOrange: "#E86A0D",
  primaryButtonOrangeHover: "#BA550A",
  primaryButtonOrangeDisabled: "#F8D1B4",
  comparisionFiltersBorder: "#ced5dd",
  navyBlue: "#2F4DDB",
  blackButton: "#000000",
  cancelRed: "#ED1C24",
  trackingHelpBoxBG: "#fff1e7",
  primaryButtonOrangeLight: "#FCE9DB",
  textGrey: "#64748B",
  textDarkergrey: "#6B7280",
  productBackground: "#F4EDE4",
  titleDarkText: "#0F172A",
  homepageTealBG: "#1F5F5B",
  homepageNudeBG: "#FFFEF6",
};

export default colors;

export const beerPalette = [
  "#F69778",
  "#55BFD2",
  "#A7A4A7",
  "#EEC34DC4",
  "#0098A2",
  "#7EC0C6",
  "#ADAEAD",
  "#BDDBDD",
];
